// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pageContainer___7hn3J{padding:88px 40px 0;width:100%}.headerText___k9tNW{font-size:22px}.tableContainer___4kl3U{width:100%}\n", "",{"version":3,"sources":["webpack://./src/routes/Revisions/Revisions.css"],"names":[],"mappings":"AAAA,uBAAA,mBAAA,CAEI,UAAA,CAGJ,oBACI,cAAA,CAGJ,wBACI,UAAA","sourcesContent":[".pageContainer {\n    padding: 88px 40px 0 40px;\n    width: 100%;\n}\n\n.headerText {\n    font-size: 22px;\n}\n\n.tableContainer {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": "pageContainer___7hn3J",
	"headerText": "headerText___k9tNW",
	"tableContainer": "tableContainer___4kl3U"
};
export default ___CSS_LOADER_EXPORT___;
